import './sortBy.scss';
import { Box, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { usePartnerPmsContext } from '../../contexts/PartnerPmsContext';
import Button from '../Button';
import { PartnerPmsSortByData, PartnerPmsSortByEnum } from '../../data/Enums';


const SortBy: React.FC = () => {
    const { translate } = useLanguageContext();
    const { 
        selectedOccupancyStatus,
        selectedGovernanceStatus,
        selectedRoomStatus,
        selectedBlock,
        selectedFloor,
        selectedRoomType, 
        onlyUserRooms, 
        sortBy,
        handleChangeSelectedFilters 
    } = usePartnerPmsContext();


    const _handleApplyFilters = useCallback((sortBy: PartnerPmsSortByEnum) => {
        handleChangeSelectedFilters( 
            selectedOccupancyStatus, 
            selectedGovernanceStatus, 
            selectedRoomStatus,
            selectedBlock, 
            selectedFloor, 
            selectedRoomType,
            onlyUserRooms,
            sortBy
        );
        // eslint-disable-next-line
    }, [selectedOccupancyStatus, selectedGovernanceStatus, selectedRoomStatus, selectedBlock, selectedFloor, selectedRoomType, onlyUserRooms]);
    

    return <Box className='partnerpms-sortby'>
        <Typography variant='subtitle2' className='sortby-title'>
            {translate('sortBy')}
        </Typography>

        <Box className='sortby-items'>
            {
                Object.values(PartnerPmsSortByData).map(row => {
                    const selected = row.key === sortBy;

                    return <Button 
                        label={translate(row.name)}
                        onClick={() => _handleApplyFilters(row.key as PartnerPmsSortByEnum)}
                        className={`text-alwaysshow sortby-item ${selected ? 'selected' : ''}`}
                        size='small'
                        fullWidth={false}
                        startIcon={row.Icon ? <row.Icon /> : undefined}
                    />;
                })
            }
        </Box>
    </Box>;
}

export default SortBy;